import { Box, Typography } from '@mui/material';

/**
 * The mark is a stylized shell-and-tube cross-section: an outer shell with
 * tube passes running through it.
 */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 32 32"
      sx={{ width: size, height: size, flexShrink: 0, display: 'block' }}
      aria-hidden="true"
    >
      <rect x="1.5" y="6.5" width="29" height="19" rx="5" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <path d="M7 12h18M7 16h18M7 20h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
    </Box>
  );
}

export function Logo({ size = 30 }: { size?: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, color: 'primary.main' }}>
      <LogoMark size={size} />
      <Typography
        component="span"
        sx={{ fontWeight: 800, fontSize: size * 0.62, letterSpacing: '-0.03em', color: 'text.primary' }}
      >
        HXIQ
      </Typography>
    </Box>
  );
}
